import React, { useState, useEffect } from 'react';
import { GlobalContainer } from '../../common/components/Container';
import BannerTitle from '../../common/components/BannerTitle';
import { StyledDataGrid } from '../../common/components/DataGrid/styles';
import { Tooltip, Box, LinearProgress } from '@mui/material';
import { getCases } from '../../api/caseApi';
import { getPaymentSummary } from '../../api/caseApi';

const PaymentSummary = () => {
    const [pageSize, setPageSize] = useState(25);
    const [dataRow, setDataRow] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect (() => {
        fetchPatients();
    }, [])

    const fetchPatients = async () => {
        setLoading(true);
        try {
            const response = await getCases();
            const response2 = await getPaymentSummary();
            console.log(response2);
            const fullName = response.map(item => item.patient.firstName + " " + item.patient.lastName);
            const clinicName = response.map(item => `${item.dentist == null ? "" : item.dentist.dentalClinic.name}`);
            const totalFee = response.map(item => (item.treatmentTypeTotalAmount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })));
            const totalCollections = response2.map(item => (item.totalAmount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })));    
            const totalOutstanding = totalFee.map((value, index) => (
                (Number(value.replace(/[^0-9.-]+/g,"")) - Number(totalCollections[index].replace(/[^0-9.-]+/g,""))).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
            ));     
            const planOfPayment = response2.map(item => item.termsOfPayment);
            const newRow = fullName.map((value, index) => ({
                id: index + 1,
                patientName: value,
                dentalClinicName: clinicName[index],
                alinaFee: totalFee[index],
                totalCollections: totalCollections[index],
                totalOutstanding: totalOutstanding[index],
                planOfPayment: planOfPayment[index],
            })); 
            const idCase = response.map(item => item.id);
            setDataRow(newRow);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const columns = [
        {
            field: "patientName",
            headerName: "Patient Name",
            headerClassName: "column-header",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                  <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "dentalClinicName",
            headerName: "Dental Clinic",
            headerClassName: "column-header",
            flex: 1.2,
            renderCell: (params) => (
              <Tooltip title={params.value}>
                <span>{params.value}</span>
              </Tooltip>
            ),
        },
        {
            field: "alinaFee",
            headerName: "Alina Fee",
            headerClassName: "column-header",
            flex: 1.2,
            renderCell: (params) => (
              <Tooltip title={params.value}>
                <span>{params.value}</span>
              </Tooltip>
            ),
        },
        {
            field: "totalCollections",
            headerName: "Total Collections",
            headerClassName: "column-header",
            flex: 1.2,
            renderCell: (params) => (
              <Tooltip title={params.value}>
                <span>{params.value}</span>
              </Tooltip>
            ),
            
        },
        {
            field: "totalOutstanding",
            headerName: "Total Outstanding",
            headerClassName: "column-header",
            flex: 1.2,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                  <span>{params.value}</span>
            </Tooltip>
            ),
            // sortable:false
        },
        {
            field: "planOfPayment",
            headerName: "Plan of Payment",
            headerClassName: "column-header",
            flex: 1.6,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                  <span>{params.value}</span>
            </Tooltip>
            ),
        },
    ]; 
    
    return (
        <GlobalContainer theme="purple">
            <BannerTitle type="banner" theme="purple">
                Payment Summary
            </BannerTitle>

            <Box sx={{ "& .column-header": { backgroundColor: "#F0F0F0", }}}>
            <StyledDataGrid
                autoHeight
                rows={dataRow}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[25, 50, 100]}
                pagination
                loading={loading}
            />  
            </Box>
        </GlobalContainer>
      
    );
}

export default PaymentSummary;

